import { useNavigate } from 'react-router-dom';
import { useZoomStore } from '@/shared/store/zoomStore';

// Navigate from the Home canvas into a RECORD, seeding a "Home" breadcrumb in
// the sub-nav so it reads "Home › <record>" and returning (crumb click / Esc)
// goes back to Home rather than the record's list page. Non-record pages
// navigate normally, with no crumb (pass isRecord=false).
export function useHomeNav() {
  const nav = useNavigate();
  const push = useZoomStore((s) => s.push);
  return (path: string, isRecord = true) => {
    if (isRecord) push({ path: '/', label: 'Home' });
    nav(path);
  };
}
